/**
 * Better Auth sign-up route configuration.
 */

import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/sign-up')({})
